<template>
	<!-- 用户中心页面 -->
	<div class="user_wrap">
		<!-- 顶部用户信息区域 -->
		<div class="user_header_section">
			<!-- 签到入口 -->
			<div class="sign_btn" @click="$router.push('/sign')">
				<img src="../images/user/sign.png">
			</div>

			<!-- 用户头像和信息 -->
			<div class="user_info">
				<div class="avatar">
					<img :src="data.user_icon" alt="">
				</div>
				<div class="info">
					<div class="name">{{ data.name ? data.name : data.mobile }}</div>
					<div class="vip_badge">
						<div class="vip_icon"></div>
						<span>{{ data.vip_name }}</span>
					</div>
				</div>
			</div>

			<!-- 总余额 -->
			<!-- <div class="total_balance">
				<div class="balance_label">
					{{ $t('user.totalBalance') }}
					<van-icon :name="eye ? 'eye-o' : 'closed-eye'" @click="eye = !eye" />
				</div>
				<div class="balance_amount">{{ eye ? data.all_money : '******' }}</div>
			</div> -->
		</div>

		<!-- 数据统计卡片 -->
		<!-- <div class="stats_card">
			<div class="stat_item">
				<div class="stat_value">{{ eye ? data.wait_money : '******' }}</div>
				<div class="stat_label">{{ $t('user.uncollectedPrincipal') }}</div>
			</div>
			<div class="stat_item">
				<div class="stat_value">{{ eye ? data.wait_lixi : '******' }}</div>
				<div class="stat_label">{{ $t('user.uncollectedInterest') }}</div>
			</div>
			<div class="stat_item">
				<div class="stat_value">{{ eye ? data.all_lixi : '******' }}</div>
				<div class="stat_label">{{ $t('user.cumulativeIncome') }}</div>
			</div>
		</div> -->

		<!-- 功能菜单 -->
		<div class="menu_section">
			<div class="menu_item" @click="$router.push('/moneybag')">
				<div class="menu_icon wallet">
					<img src="../images/user/moneybag.png" alt="" />
				</div>
				<div class="menu_name">{{ $t('user.myWallet') }}</div>
				<van-icon name="arrow" />
			</div>
			<div class="menu_item" @click="$router.push('/rechargeRecord')">
				<div class="menu_icon recharge">
					<img src="../images/user/cz.png" alt="" />
				</div>
				<div class="menu_name">{{ $t('user.rechargeRecord') }}</div>
				<van-icon name="arrow" />
			</div>
			<div class="menu_item" @click="$router.push('/withdrawRecord')">
				<div class="menu_icon withdraw">
					<img src="../images/user/tx.png" alt="" />
				</div>
				<div class="menu_name">{{ $t('user.withdrawalRecord') }}</div>
				<van-icon name="arrow" />
			</div>
			<div class="menu_item" @click="$router.push('/address')">
				<div class="menu_icon address">
					<img src="../images/user/setting.png" alt="" />
				</div>
				<div class="menu_name">收货地址</div>
				<van-icon name="arrow" />
			</div>
			<div class="menu_item" @click="$router.push('/myTeam')">
				<div class="menu_icon team">
					<img src="../images/user/team.png" alt="" />
				</div>
				<div class="menu_name">{{ $t('index.invite') }}</div>
				<van-icon name="arrow" />
			</div>
			<div class="menu_item" @click="$router.push('/safe')">
				<div class="menu_icon setting">
					<img src="../images/user/setting.png" alt="" />
				</div>
				<div class="menu_name">{{ $t('user.setting') }}</div>
				<van-icon name="arrow" />
			</div>
		</div>

		<!-- 在线客服 -->
		<div class="service_btn" @click="$router.push('/kefu')">
			<img src="../images/user/kf.png" alt="" />
			<span>{{ $t('user.onlineService') }}</span>
		</div>
	</div>
</template>

<script>
/**
 * 用户中心页面组件
 * 显示用户信息、账户余额、数据统计和功能菜单
 */
import Vue from 'vue';
import Fetch from '../../utils/fetch';
import { Icon } from "vant";

Vue.use(Icon);

export default {
	name: "user",
	/**
	 * 组件数据
	 * @returns {Object} 数据对象
	 * @returns {Object} data - 用户信息数据
	 * @returns {boolean} eye - 余额是否可见
	 */
	data() {
		return {
			data: {},
			eye: true,
		};
	},
	created() {
		this.$parent.footer('user');
	},
	mounted() {
		this.loadUserInfo();
	},
	methods: {
		/**
		 * 加载用户信息
		 * 获取用户基本信息和账户数据
		 */
		loadUserInfo() {
			Fetch('/user/info').then((r) => {
				this.data = r.data;
			});
		},
	}
};
</script>

<style lang="less" scoped>
/**
 * 用户中心页面样式
 * 采用卡片式设计，与其他页面保持一致的视觉风格
 */
.user_wrap {
	min-height: 100vh;
	background-color: #f5f5f5;
	padding-bottom: 30px;
}

/* 顶部用户信息区域 */
.user_header_section {
	position: relative;
	background: linear-gradient(135deg, #ff6b6b 0%, #ff5252 100%);
	// padding: 20px 20px 60px;
	padding: 20px 20px 20px;

	.sign_btn {
		position: absolute;
		top: 15px;
		right: 15px;
		height: 24px;
		cursor: pointer;

		img {
			height: 100%;
		}
	}

	.user_info {
		display: flex;
		align-items: center;
		margin-bottom: 20px;

		.avatar {
			width: 60px;
			height: 60px;
			border-radius: 50%;
			overflow: hidden;
			border: 3px solid rgba(255, 255, 255, 0.5);
			margin-right: 15px;

			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
		}

		.info {
			.name {
				font-size: 18px;
				font-weight: 600;
				color: #fff;
				margin-bottom: 8px;
			}

			.vip_badge {
				display: inline-flex;
				align-items: center;
				background: linear-gradient(to right, #ffa51e, #ffe462);
				padding: 2px 12px 2px 8px;
				border-radius: 12px;
				font-size: 12px;
				color: #8B6914;

				.vip_icon {
					width: 20px;
					height: 20px;
					margin-right: 4px;
					background-image: url(../images/user/badge.png);
					background-position: center;
					background-repeat: no-repeat;
					background-size: 100% 100%;
				}
			}
		}
	}

	.total_balance {
		.balance_label {
			font-size: 13px;
			color: rgba(255, 255, 255, 0.8);
			margin-bottom: 8px;
			display: flex;
			align-items: center;

			.van-icon {
				font-size: 18px;
				margin-left: 8px;
				cursor: pointer;
			}
		}

		.balance_amount {
			font-size: 32px;
			font-weight: bold;
			color: #fff;
			text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
		}
	}
}

/* 数据统计卡片 */
.stats_card {
	display: flex;
	margin: -40px 15px 0;
	background: #fff;
	border-radius: 12px;
	padding: 20px 10px;
	box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
	position: relative;
	z-index: 1;

	.stat_item {
		flex: 1;
		text-align: center;
		border-right: 1px solid #f0f0f0;

		&:last-child {
			border-right: none;
		}

		.stat_value {
			font-size: 18px;
			font-weight: 600;
			color: #ff5252;
			margin-bottom: 6px;
		}

		.stat_label {
			font-size: 12px;
			color: #999;
		}
	}
}

/* 功能菜单 */
.menu_section {
	margin: 15px;
	background: #fff;
	border-radius: 12px;
	box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
	overflow: hidden;

	.menu_item {
		display: flex;
		align-items: center;
		padding: 16px 20px;
		border-bottom: 1px solid #f5f5f5;
		cursor: pointer;
		transition: background 0.2s;

		&:last-child {
			border-bottom: none;
		}

		&:hover {
			background: #f9f9f9;
		}

		.menu_icon {
			width: 40px;
			height: 40px;
			border-radius: 10px;
			display: flex;
			align-items: center;
			justify-content: center;
			margin-right: 15px;

			img {
				width: 22px;
				height: 22px;
			}

			&.wallet {
				// background: linear-gradient(135deg, #ff6b6b 0%, #ff5252 100%);
			}

			&.recharge {
				// background: linear-gradient(135deg, #4ecdc4 0%, #44bd64 100%);
			}

			&.withdraw {
				// background: linear-gradient(135deg, #f6d365 0%, #fda085 100%);
			}

			&.team {
				// background: linear-gradient(135deg, #a18cd1 0%, #fbc2eb 100%);
			}

			&.address {
				background: linear-gradient(135deg, #a18cd1 0%, #fbc2eb 100%);
			}

			&.setting {
				// background: linear-gradient(135deg, #89f7fe 0%, #66a6ff 100%);
			}
		}

		.menu_name {
			flex: 1;
			font-size: 15px;
			color: #333;
		}

		.van-icon {
			font-size: 16px;
			color: #ccc;
		}
	}
}

/* 在线客服按钮 */
.service_btn {
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 15px;
	padding: 14px;
	background: linear-gradient(135deg, #ff6b6b 0%, #ff8244 100%);
	border-radius: 12px;
	box-shadow: 0 4px 15px rgba(255, 82, 68, 0.3);
	cursor: pointer;
	transition: all 0.3s ease;

	&:active {
		transform: scale(0.98);
	}

	img {
		width: 28px;
		height: 28px;
		margin-right: 10px;
	}

	span {
		font-size: 15px;
		font-weight: 600;
		color: #fff;
	}
}
</style>
